// extracted by mini-css-extract-plugin
export var modal = "_ir-0";